import { ClickEvent, OpenType, TableRowDisplayEvent, Textbox } from "@mcleod/components";
import { AutogenLayoutDrsSettleHist } from "./autogen/AutogenLayoutDrsSettleHist";
import { OrderTabView } from "@mcleod/dispatch";
import { Navigation, StringUtil } from "@mcleod/core";
import { LabelStyles } from "@mcleod/components/src/components/label/LabelStyles";

export class DrsSettleHist extends AutogenLayoutDrsSettleHist {

    onLoad(): void | Promise<void> {
        this.tableDrsHist.crudManager.defaultOpenType = OpenType.NEW_TAB_WITH_SWITCH;
    }

    tableDrsHistOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        const orderIdLabel = tableRow.findComponentById("labelOrderId") as Textbox;
        if (orderIdLabel != null && !StringUtil.isEmptyString(orderIdLabel.text)) {
            if (orderIdLabel.text?.startsWith("M")) {
                orderIdLabel.tooltip = "Click to view manifest";
            } else {
                orderIdLabel.tooltip = "Click to view order";
            }
            orderIdLabel.setClassIncluded(LabelStyles.link, true);
            orderIdLabel.addUnderlineWhenMouseOver();
            orderIdLabel.addClickListener((event: ClickEvent) => this.labelOrderIdOnClick(event));
        }
    }

    labelOrderIdOnClick(event: ClickEvent) {
        const orderOrManifestId = (event.target as Textbox)?.text;
        if (!StringUtil.isEmptyString(orderOrManifestId)) {
            if (orderOrManifestId?.startsWith("M")) {
                Navigation.navigateTo("lme/dispatch/OrderList?manifest_id=" + orderOrManifestId, { newTab: true });
            } else {
                OrderTabView.navigateTo({ key: orderOrManifestId, newTab: true });
            }
        }
    }
}
